import { Route, BrowserRouter, Routes, Navigate, Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from 'react-query';

import { MerchandiseOptions } from "./modules/Assortment/MerchandiseOptions";
import { MixQualificationScreen } from "./modules/Assortment/MixQualificationScreen";
import { OportunidadesSortimentoScreen } from "./modules/Assortment/OportunidadesSortimentoScreen";
import { MercadosConvenienciasScreen } from "./modules/Assortment/MercadosConvenienciasScreen";

import { TenantProvider } from "./templates/context/TenantContext";

import { Login } from "./modules/Login/Login";

import { Settings } from "./modules/Settings/Settings";

import { DataIntegrationScreen } from "./modules/DataIntegration/DataIntegrationScreen";

import { AssortmentScreen } from "./modules/Assortment/assortment.index";

import { PerformanceAnalysisProduct } from "./modules/Products/PerformanceAnalysis/PerformanceAnalysisProduct";
import { ProductAnalyticsScreen } from "./modules/Products/ProductAnalytics/ProductAnalyticsScreen";
import { AdjustmentsSupply } from "./modules/Products/AdjustmentsSupply/AdjustmentsSupply";
import { OTBAdjustments } from "./modules/Products/OTB_Adjustments/OTBAdjustments";
import { OtbPlanningScreen } from "./modules/OtbPlanning/OtbPlanningScreen";
import { PlanoDeCompraScreen } from "./modules/OtbPlanning/PlanoDeCompraScreen";
import { OtbDetalhado } from "./modules/OtbPlanning/OtbDetalhado";

import { 
  PlanVsForecast, 
  Accuracy, 
  Checkout,
  Opportunity,
  OpportunityInsightsScreen 
} from './modules/AnalysisModule/analysysModuleViews';

import { SalesRecomendation, MeasurementUnits, PurchaseHistory, PurchaseQuality} from "./modules/PurchaseManagementModule/purchaseManagementViews";

import GlobalStyles from "./styles/GlobalStyles/GlobalStyles";
import "./styles/molecules.css";
import "./styles/carousel.css";
import "./styles/styles.css";

import { AuthGate } from "./templates/AuthGate";

import { ROUTES_APPLICATION_PATH } from './routes.constants';

import { HomeStrategy } from "./viewModel/strategy/home/home.strategy";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

const PrivateLayout = () => {
  const isAuthenticated = localStorage.getItem('token') !== null;
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return (
    <AuthGate>
      <TenantProvider>
        <Outlet />
      </TenantProvider>
    </AuthGate>
  );
};

export function AppRoutes() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<PrivateLayout />}>
            <Route path={ROUTES_APPLICATION_PATH.HOME.BASE_URL} element={<HomeStrategy />} />

            <Route path={ROUTES_APPLICATION_PATH.ANALYSIS.COMPONENT_URL[0]} element={<PlanVsForecast />} />
            <Route path={ROUTES_APPLICATION_PATH.ANALYSIS.COMPONENT_URL[1]} element={<Accuracy />} />

            <Route path={ROUTES_APPLICATION_PATH.SETTINGS.BASE_URL} element={<Settings />} />

            <Route path={ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[0]} element={<Opportunity />} />
            <Route path={ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[1]} element={<Checkout />} />
            <Route path={ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[2]} element={<OpportunityInsightsScreen />} />

            <Route path={ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[0]} element={<SalesRecomendation />} />
            <Route path={ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[1]} element={<PurchaseHistory />} />
            <Route path={ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[2]} element={<MeasurementUnits />} />
            <Route path={ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[3]} element={<AssortmentScreen />} />

            <Route path={ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[0]} element={<MerchandiseOptions />} />
            <Route path={ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[1]} element={<MixQualificationScreen />} />
            <Route path={ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[2]} element={<OportunidadesSortimentoScreen />} />
            <Route path={ROUTES_APPLICATION_PATH.SORTIMENTO.COMPONENT_URL[3]} element={<MercadosConvenienciasScreen />} />

            <Route path={ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[0]} element={<PerformanceAnalysisProduct />} />
            <Route path={ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[1]} element={<OTBAdjustments />} />
            <Route path={ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[2]} element={<AdjustmentsSupply />} />
            <Route path={ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[3]} element={<OtbPlanningScreen/>}/>
            <Route path={ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[4]} element={<PlanoDeCompraScreen/>}/>
            <Route path={ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[5]} element={<OtbDetalhado/>}/>
            <Route path={ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[6]} element={<ProductAnalyticsScreen/>}/>

            <Route path={ROUTES_APPLICATION_PATH.PURCHASE_QUALITY.COMPONENT_URL[0]} element={<PurchaseQuality />} />

            <Route path={ROUTES_APPLICATION_PATH.DATA_INTEGRATION.BASE_URL} element={<DataIntegrationScreen />} />
            
          </Route>
        </Routes>
        <GlobalStyles />
      </QueryClientProvider>
    </BrowserRouter>
  );
}